import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled';

import { useChildren } from '../../hooks/useChildren.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIRowProps, JustifyValue, AlignValue } from '../../types/A2UIComponents.types.tsx';

type InlineAlignInline = 'start' | 'center' | 'end' | 'stretch';
type InlineAlignBlock = 'start' | 'center' | 'end' | 'stretch' | 'baseline';

const mapJustify = (
	justify?: JustifyValue,
): {
	alignInline?: InlineAlignInline;
	spread?: 'space-between';
	xcssKey?: 'spaceAround' | 'spaceEvenly';
} => {
	switch (justify) {
		case 'start':
		case 'center':
		case 'end':
		case 'stretch':
			return { alignInline: justify };
		case 'spaceBetween':
			return { spread: 'space-between' };
		case 'spaceAround':
			return { xcssKey: 'spaceAround' };
		case 'spaceEvenly':
			return { xcssKey: 'spaceEvenly' };
		default:
			return {};
	}
};

const mapAlign = (align?: AlignValue): InlineAlignBlock | undefined => {
	return align;
};

type Props = {
	definition: A2UIComponentDefinition;
	visited?: Set<string>;
};

export const A2UIRow = ({ definition, visited }: Props): React.JSX.Element => {
	const def = definition as A2UIRowProps;
	const children = useChildren(def.children, visited);
	const { alignInline, spread } = mapJustify(def.justify);
	const alignBlock = mapAlign(def.align);

	return (
		<Inline
			space="space.100"
			alignInline={alignInline}
			alignBlock={alignBlock}
			spread={spread}
			shouldWrap
		>
			{children}
		</Inline>
	);
};
